import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetStudentsPaginatedForRoomData, IGetDigitalStudentsPaginatedQueryVars } from '../types';

export const GET_STUDENTS_PAGINATED_FOR_ROOM: TypedDocumentNode<
  IGetStudentsPaginatedForRoomData,
  IGetDigitalStudentsPaginatedQueryVars
> = gql`
  query getPaginatedStudentForRoom($input: PaginatedStudentInput) {
    paginatedStudentForRoom(input: $input) {
      lastKey
      students {
        id
        absent
        candRegNo
        deniedEntry
        groupType
        room {
          id
        }
        __typename
      }
      __typename
    }
  }
`;
